export default (el) => ({
  id: Number(el.Value),
  label: String(el.Text).trim(),
  disabled: Boolean(el.Disabled),
  selected: Boolean(el.Selected),
  group: el.Group || null,
});
